<template>
  <div>
    <template v-if="attempt>0">
      <template v-if="attempt >= Number(itemData.exam_attempts)">
        <div class="alert__wrapper">
          <p
            class="alert alert-danger"
            role="alert"
          >You are out of attempts and can not take this exam again</p>
        </div>
      </template>
      <template v-else>
        <div v-if="quizResult >= itemData.pass_grade" class="result__wrapper">
          <p>
            You have already completed this Assessment and earned a passing grade of
            <strong>{{quizResult}}%</strong>. Please visit your profile to view and download your certificate
          </p>
          <router-link
            class="btn btn-accent text-white"
            active-class="active"
            :to="{name: 'user-profile', params: {id}}"
            exact
          >My Profile</router-link>
        </div>

        <div v-else>
          <template v-if="agreementStatus === false">
            <ExamInstructionModal :itemData="itemData"/>
          </template>
          <div v-else class="quiz">
            <div class="module__wrapper module__wrapper--between">
              <div>
                Attempts:
                <span class="bold">{{attempt}}/{{itemData.exam_attempts}}</span>
              </div>
              <div class="time__wrapper">
                <h5 class="title">Countdown Timer</h5>
                <span class="time">{{minutes}}:{{seconds}}</span>
              </div>
            </div>
            <div v-if="quizStart && !quizSubmitted" class="quiz__meta">
              <span ref="progress" class="level">
                course progress:
                <span v-if="progress" class="bold">{{`${progress}%`}}</span>
                <span v-else class="bold">0%</span>
              </span>
            </div>
            <template v-if="quizIntro">
              <div class="center">
                <h6>Hello, we noticed you scored below the pass mark. Do take the exams again if you wish to be certified in this course.</h6>
                <p class="bold pb-10">Click the button below to start the timer to retake quiz</p>
                <button
                  @click="startQuiz"
                  type="button"
                  class="btn__primary btn__primary--alt"
                >Start Assessment</button>
              </div>
            </template>
            <template v-if="quizStart">
              <div class="quiz__heading">
                <h4 class="quiz__primary">{{ itemData.title }}</h4>
                <h5 class="quiz__secondary">Please answer all questions.</h5>
              </div>
              <div class="quiz__body">
                <form @submit.prevent="submitQuiz" class="form__quiz" action>
                  <Question
                    :key="key"
                    :selectedAnswer="scoreArray[currentQuizIndex]"
                    :question="quizzes[currentQuizIndex]"
                    :question-index="currentQuizIndex + 1"
                    :reset="reset"
                  />
                  <template v-if="currentQuizIndex === (quizzes.length - 1)">
                    <button type="submit" class="btn btn__quiz" @click.prevent="submitQuiz">Submit</button>
                  </template>
                  <template v-else>
                    <div class="d-flex">
                      <!-- <button
                        :disabled="currentQuizIndex === 0"
                        @click.prevent="prevQuiz"
                        type="button"
                        class="btn btn__quiz btn__quiz--alt"
                      >Prev</button>-->
                      <button @click.prevent="nextQuiz" type="submit" class="btn btn__quiz">Next</button>
                    </div>
                  </template>
                </form>
              </div>
            </template>
            <template v-if="quizSubmitted">
              <div class="center">
                <div class>
                  <p>Your score is {{percentage}}</p>
                </div>
                <div v-if="percentage >= itemData.pass_grade" class>
                  <h4>Well done!</h4>
                  <h5 class="bold">You have earned a Certificate</h5>
                </div>
                <div v-else-if="!quizStart">
                  <h5 class="bold">
                    Hello, we noticed you scored below the pass mark. Do take the exams again if you wish to be certified in this course.
                    You have {{ (itemData.exam_attempts - attempt) }} more trie(s) to reach the passmark.
                  </h5>

                  <button
                    @click="restartQuiz"
                    type="button"
                    class="btn__primary btn__primary--alt"
                  >Retake Assessment</button>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </template>
    <template v-else-if="agreementStatus === false">
      <ExamInstructionModal :itemData="itemData"/>
    </template>
    <template v-else>
      <template v-if="quizLoaded && quizzes.length">
        <div class="quiz">
          <div class="module__wrapper module__wrapper--between">
            <div>
              Attempts:
              <span class="bold">{{attempt}}/{{itemData.exam_attempts}}</span>
            </div>
            <div class="time__wrapper">
              <h5 class="title">Countdown Timer</h5>
              <span class="time">{{minutes}}:{{seconds}}</span>
            </div>
          </div>
          <div v-if="quizStart && !quizSubmitted" class="quiz__meta">
            <span ref="progress" class="level">
              course progress:
              <span v-if="progress" class="bold">{{`${progress}%`}}</span>
              <span v-else class="bold">0%</span>
            </span>
          </div>
          <div class="quiz__main">
            <template v-if="quizIntro">
              <div class="center">
                <h4>Welcome to the quiz</h4>
                <p class="pb-10">Click the button below to start the timer for your quiz</p>
                <button
                  @click="startQuiz"
                  type="button"
                  class="btn__primary btn__primary--alt"
                >Start</button>
              </div>
            </template>
            <template v-if="quizStart">
              <div class="quiz__heading">
                <h4 class="quiz__primary">{{ itemData.title }}</h4>
                <h5 class="quiz__secondary">Please answer all questions.</h5>
              </div>
              <div class="quiz__body">
                <form @submit.prevent="submitQuiz" class="form__quiz" action>
                  <Question
                    :key="key"
                    :selectedAnswer="scoreArray[currentQuizIndex]"
                    :question="quizzes[currentQuizIndex]"
                    :question-index="currentQuizIndex + 1"
                    :reset="reset"
                  />
                  <template v-if="currentQuizIndex === (quizzes.length - 1)">
                    <div class="d-flex">
                      <!-- <button
                        :disabled="currentQuizIndex === 0"
                        @click.prevent="prevQuiz"
                        type="submit"
                        class="btn btn__quiz btn__quiz--alt"
                      >Prev</button>-->
                      <button type="submit" class="btn btn__quiz" @click.prevent="submitQuiz">Submit</button>
                    </div>
                  </template>
                  <template v-else>
                    <div class="d-flex">
                      <button
                        :disabled="currentQuizIndex <= 1"
                        @click.prevent="prevQuiz"
                        type="submit"
                        class="btn btn__quiz btn__quiz--alt"
                      >Prev</button>
                      <button @click.prevent="nextQuiz" type="submit" class="btn btn__quiz">Next</button>
                    </div>
                  </template>
                </form>
              </div>
            </template>
            <template v-if="quizSubmitted">
              <div class="center">
                <h4 class="bold">Your score is {{percentage}}</h4>
                <div v-if="percentage >= itemData.pass_grade" class>
                  <h4>Well done!</h4>
                  <h5 class="bold">You have earned a Certificate</h5>
                </div>
                <div v-else>
                  <h5>
                    Hello, we noticed you scored below the pass mark. Do take the assessment again if you wish to be certified in this course.
                    You have {{ (itemData.exam_attempts - attempt) }} more attempt(s) to reach the passmark.
                  </h5>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
      <template v-else-if="quizLoaded">
        <div class="result__wrapper">
          <p>No quiz available yet</p>
        </div>
      </template>
      <template v-else>
        <div class="result__wrapper">
          <p>Error Loading quiz</p>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCourseQuiz, getUserCourseAttempts } from "../../utils/api/course";
import { submitScores } from "../../utils/api/quiz";
import { getUserScores } from "../../utils/api/user";
import eventHub from "../../utils/eventhub";
import Question from "./Question";
import { success, fail } from "../../utils/toast";
import Loader from "../../components/Loader";
import ExamInstructionModal from "./ExamInstructionModal";
import { setTimeout } from "timers";

export default {
  name: "CourseQuiz",
  props: {
    done: {
      type: Boolean,
      default() {
        return false;
      }
    },
    itemData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      id: this.$session.get("id"),
      quizzes: [],
      loadingQuiz: false,
      quizLoaded: false,
      total: 0,
      currentQuizIndex: 0,
      quizIntro: false,
      quizStart: false,
      quizSubmitted: false,
      quizResult: "",
      result: null,
      score: 0,
      timer: null,
      timelimit: 1,
      totalTime: 0,
      percentage: 0,
      response: [],
      reset: false,
      attempt: 0,
      key: 0,
      scoreArray: [],
      agreementStatus: false
    };
  },
  created() {
    this.getQuiz();
    this.getScores();
    this.getUserAttempts();
    eventHub.$on("result", payload => {
      this.score += payload;
    });
    eventHub.$on("answer", payload => {
      this.scoreArray[this.currentQuizIndex] = payload;
    });
    eventHub.$on("changed-instruction-status", payload => {
      this.agreementStatus = payload;
    });
    this.totalTime = this.timelimit * this.itemData.exam_duration;
  },
  mounted() {
    if (this.done) {
      this.getScores();
    }
  },
  watch: {
    score(value) {
      this.percentage = (value / this.quizzes.length) * 100;
    },
    progress() {
      this.setProgressWidth();
    }
  },
  computed: {
    ...mapGetters({
      joinedCourse: "getJoinedStatus",
      user: "getLoggedUser"
    }),
    progress() {
      if (this.quizStart) {
        return ((this.currentQuizIndex + 1) / this.quizzes.length) * 100;
      }
      return 0;
    },
    minutes() {
      const minutes = Math.floor(this.totalTime / 60);
      return minutes < 10 ? `0${minutes}` : minutes;
    },
    seconds() {
      const seconds = Math.floor(this.totalTime - this.minutes * 60);
      return seconds < 10 ? `0${seconds}` : seconds;
    }
  },
  methods: {
    getScores() {
      getUserScores(this.$session.get("id"))
        .then(response => {
          if (response.status === 200) {
            const courseId =
              this.$route.params.id || this.$route.params.onlineClassId;
            const course = response.data.data;
            this.quizResult = course.find(
              item => item.online_class_id == courseId
            ).score;
          }
        })
        .catch(error => {
          return error;
        });
    },
    getQuiz() {
      getCourseQuiz(this.$route.params.id || this.$route.params.onlineClassId)
        .then(response => {
          if (response.status === 200) {
            this.quizzes = response.data.data;
            this.total = response.data.total;
            this.loadingQuiz = false;
            this.quizLoaded = true;
            this.quizIntro = true;
          }
        })
        .catch(error => {
          this.quizLoaded = false;
          this.loadingQuiz = false;
          return error;
        });
      return true;
    },
    getUserAttempts() {
      getUserCourseAttempts(this.$route.params.id, this.user.id)
        .then(response => {
          if (response.status === 200) {
            this.attempt = response.data.data.attempt;
          }
        })
        .catch(error => {
          return error;
        });
    },
    startQuiz() {
      this.quizIntro = false;
      this.quizStart = true;
      this.quizSubmitted = false;
      this.scoreArray = [];
      this.currentQuizIndex = 0;
      this.startTimer();
      this.setProgressWidth();
    },
    restartQuiz() {
      (this.quizzes = []),
        (this.loadingQuiz = false),
        (this.quizLoaded = false),
        (this.total = 0),
        (this.currentQuizIndex = 0),
        (this.quizIntro = false),
        (this.quizStart = false),
        (this.quizSubmitted = false),
        (this.quizResult = ""),
        (this.result = null),
        (this.score = 0),
        (this.timer = null),
        (this.timelimit = 1),
        (this.totalTime = 0),
        (this.percentage = 0),
        (this.response = []),
        (this.reset = false),
        (this.attempt = 0),
        (this.key = 0),
        (this.scoreArray = []),
        (this.agreementStatus = false);

      this.getQuiz();

      this.getUserAttempts();
      eventHub.$on("result", payload => {
        this.score += payload;
      });
      eventHub.$on("answer", payload => {
        this.scoreArray[this.currentQuizIndex] = payload;
      });
      eventHub.$on("changed-instruction-status", payload => {
        this.agreementStatus = payload;
      });
      this.totalTime = this.timelimit * this.itemData.exam_duration;
    },
    submitQuiz() {
      this.stopTimer();
      submitScores({
        online_class_id:
          this.$route.params.id || this.$route.params.onlineClassId,
        user_id: this.$session.get("id"),
        score: this.percentage
      })
        .then(response => {
          if (response.status === 201) {
            this.quizStart = false;
            this.quizSubmitted = true;
            this.getScores();
            success({
              title: "Success! You have completed the quiz!."
            });
          }
        })
        .catch(error => {
          fail({
            title: "Oops! Something went wrong",
            text: error.data
          });
          return error;
        });
    },
    nextQuiz() {
      this.currentQuizIndex += 1;
      this.reset = true;
      setTimeout(() => {
        this.reset = false;
      }, 500);
    },
    prevQuiz() {
      this.reset = true;
      this.currentQuizIndex -= 1;
      this.key += 1;
    },
    startTimer() {
      this.timer = setInterval(() => this.countdown(), 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    resetTimer() {
      this.totalTime = 1 * 60;
      clearInterval(this.timer);
      this.timer = null;
    },
    countdown() {
      if (this.totalTime >= 1) {
        this.totalTime -= 1;
      } else {
        this.totalTime = 0;
        this.submitQuiz();
        this.resetTimer();
      }
    },
    setProgressWidth() {
      setTimeout(() => {
        this.$refs.progress.style.width = `${Number(
          this.progress.toFixed(2)
        )}%`;
      }, 1000);
    }
  },
  components: {
    Question,
    Loader,
    ExamInstructionModal
  }
};
</script>

<style lang="scss" scoped>
.center {
  text-align: center;
  border: none;
  padding-top: 20px;
}
.level {
  white-space: nowrap;
}
.result__wrapper {
  text-align: center;
  padding: 30px;
  .bold {
    padding-top: 20px;
  }
}
.alert__wrapper {
  margin: 30px;
}
.btn__quiz {
  @media #{$mobile} {
    height: 42px;
    font-size: 14px;
  }
}
.btn__quiz--alt {
  background: $white;
  color: $green;
  border-color: $green;
}
.btn:disabled {
  cursor: not-allowed;
  color: $grey-light;
  border-color: $grey-light;
}
.quiz__heading {
  padding-top: 25px;
}
</style>
